import { GalaxyStationController, KeplrController, LUNCDashController, StationController, WalletController, WalletName } from "@goblinhunt/cosmes/wallet"

export const FACTORY_ADDRESS = "terra1uln3ee7w5s4vtrljdglczwx8xv9uyv46fv2vee4mkzjxq2sr02asad0uzt"
export const TOKEN_DETAIL_KEY = "TOKEN_DETAIL"

export const RPC_URL = "https://rpc-columbus-5.garuda-defi.org"
export const VERIFIED_TOKENS_URL = "https://raw.githubusercontent.com/rev1853/garuda-defi-assets/main/verified.json"
export const WC_PROJECT_ID = "90bd29bd5f8f1cf682ab8d4b07e8ff4d";

export const CLASSIC_CHAIN_ID = "columbus-5"
export const CLASSIC_GAS_PRICE = "28.325"
export const CLASSIC_DENOM = 'uluna'

export const WALLET_SETTINGS: Record<string, { controller: WalletController, name: string }> = {
    [WalletName.STATION]: {
        controller: new StationController(),
        name: "Terra Station"
    },
    [WalletName.LUNCDASH]: {
        controller: new LUNCDashController(),
        name: "LUNCdash"
    },
    [WalletName.GALAXYSTATION]: {
        controller: new GalaxyStationController(WC_PROJECT_ID),
        name: "Galaxy Station"
    },
    [WalletName.KEPLR]: {
        controller: new KeplrController(WC_PROJECT_ID),
        name: "Keplr"
    }
};

export const LIQUIDITY_STAKING_ADDRESS = "terra1x0d9yex70ngag7z5v7zcmsx6pk7fc6el5lt5qsaeycvqd7mq8vvqpak8v7";